// extracted by mini-css-extract-plugin
export default {"container":"SignupSuccess_container__bmXWR","signupCheck":"SignupSuccess_signupCheck__nDHCK","signupConfetti":"SignupSuccess_signupConfetti__spe2W"};